import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { AFF_REL, pickUrl } from "@/lib/affiliate";

interface PublicPick { id: string; name: string; note: string; store: string; store_label: string }

export function SuppliesBox({ section, src, onLoaded }: { section?: string; src: string; onLoaded?: (n: number) => void }) {
  const [picks, setPicks] = useState<PublicPick[]>([]);
  useEffect(() => {
    api.get("/public/picks", { params: { section: section || "" } })
      .then((r) => { setPicks(r.data); onLoaded?.(r.data.length); }).catch(() => setPicks([]));
  }, [section]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!picks.length) return null;
  return (
    <section className="mt-14" data-testid="supplies-box">
      <h2 className="font-heading text-xl font-semibold text-[#23324A]">Supplies I use</h2>
      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        {picks.map((p) => (
          <a key={p.id} href={pickUrl(p.id, src)} target="_blank" rel={AFF_REL} className="calm-card flex items-start justify-between gap-3 p-4" data-testid={`supply-pick-${p.id}`}>
            <span className="min-w-0">
              <span className="block font-semibold text-[#23324A]">{p.name}</span>
              {p.note && <span className="mt-1 block text-sm text-[#23324A]/70">{p.note}</span>}
              <span className="mt-2 block text-xs font-semibold text-[#D9785C]">View on {p.store_label}</span>
            </span>
            <ExternalLink className="h-4 w-4 shrink-0 text-[#23324A]/50" />
          </a>
        ))}
      </div>
    </section>
  );
}
